import Markdown from "react-markdown";
import type { Components } from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

// Custom components for Markdown rendering
const markdownComponents: Components = {
  a: (props) => (
    <a
      href={typeof props.href === "string" ? props.href : undefined}
      target="_blank"
      rel="noopener noreferrer"
      className="text-pink-600 hover:text-pink-700 underline"
    >
      {props.children}
    </a>
  ),
  p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  code: ({ children, className }) => {
    const isInline = !className;
    return isInline ? (
      <code className="bg-slate-100 px-1.5 py-0.5 rounded text-sm font-mono text-slate-800">
        {children}
      </code>
    ) : (
      <code className={className}>{children}</code>
    );
  },
  pre: ({ children }) => (
    <pre className="bg-slate-100 p-3 rounded-lg overflow-x-auto text-sm my-2">
      {children}
    </pre>
  ),
  ul: ({ children }) => (
    <ul className="list-disc list-inside mb-2 space-y-1">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="list-decimal list-inside mb-2 space-y-1">{children}</ol>
  ),
  li: ({ children }) => <li className="text-sm">{children}</li>,
  blockquote: ({ children }) => (
    <blockquote className="border-l-4 border-slate-300 pl-4 italic my-2 text-slate-600">
      {children}
    </blockquote>
  ),
  h1: ({ children }) => (
    <h1 className="text-lg font-bold mb-2 mt-3 first:mt-0">{children}</h1>
  ),
  h2: ({ children }) => (
    <h2 className="text-base font-bold mb-2 mt-3 first:mt-0">{children}</h2>
  ),
  h3: ({ children }) => (
    <h3 className="text-sm font-bold mb-2 mt-3 first:mt-0">{children}</h3>
  ),
};

export const MarkdownContent = ({ content }: { content: string }) => {
  return (
    <Markdown
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
      components={markdownComponents}
    >
      {content}
    </Markdown>
  );
};
